exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pageLoader-8cf54{width:100%;height:100%;display:flex;justify-content:center;align-items:center}", ""]);

// Exports
exports.locals = {
	"pageLoader": "pageLoader-8cf54"
};